var r=function(r){return"gb"===r?"uk":r};export{r as b};
//# sourceMappingURL=bupperizeCountry-CEtt0MKz.js.map
